import React, { useState } from 'react';
import './EmailPopup.css';

const EmailButton = () => {
  const [showPopup, setShowPopup] = useState(false);

  return (
    <>
      <button
        className="pixel-button"
        onClick={() => setShowPopup(true)}
      >
        EMAIL
      </button>

      {showPopup && (
        <>
          {/* Backdrop */}
          <div 
            className="email-popup-backdrop" 
            onClick={() => setShowPopup(false)}
          ></div>
          
          {/* Popup */}
          <div className="email-popup">
            <div className="popup-header">
              <div className="popup-title">✿ CONTACT EMAIL ✿</div>
              <button 
                className="popup-close"
                onClick={() => setShowPopup(false)}
              >
                ✕
              </button>
            </div>
            <div className="popup-body">
              <div className="email-display">
                <span className="email-part">[first name]</span>
                <span className="email-dot">.</span>
                <span className="email-part">[last name]</span>
                <span className="email-at"> at </span>
                <span className="email-domain">gmail</span>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default EmailButton;